import React, {useEffect, useState} from "react"
import { useNavigate } from "react-router-dom"

import "./WebTest.css"
import {retrieveData, sendRequest, storeData} from "../../common";
import ResultNav from "../../component/Nav/ResultNav";
import TopHeader from "../../component/Nav/TopHeader";

function WebTestIntro() {
	const navigate = useNavigate()

	return (
		<>
			<div className="container">
				<TopHeader title={"PTS의 소개"} />
				<div style={{marginLeft: 40, marginRight: 40, paddingTop: 120}}>
					<b style={{fontSize: 24}}>PTS의 소개</b>
					<div style={{letterSpacing: 1.5, whiteSpace: 'pre-wrap', lineHeight: 1.6, marginTop: 16}}>
						PTS는 지그문트 프로이트(Sigmund Freud)의 무의식 원리와 칼 구스타프 융(C. G. Jung)의 심리학적 유형론을 근거로, 그리고 무어와 키어슬리(Moore&Kearsley)의 상호작용의 원리를 인용하여 ㈜인컬리지에서 개발한 심리유형 분석 및 교육도구입니다.<br></br>

						PTS(Psychological Type Searching)에서는 인간의 심리영역을 칼 융이 언급한 외향(E)-내향(I), 감각(S)-직관(N), 사고(T)-감정(F)의 척도와 융의 원리에서 도출 및 재해석한 계획(J)-적응(P), 이완(R)-긴장(T) 척도의 조합에 따라 32가지 심리유형이 형성될 수 있습니다.
					</div>
					<div align={'center'} style={{marginTop: 40, marginBottom: 40}}>
						<img src={require('../../assets/intro1.png')} style={{width: '80%'}}/>
					</div>

					<div style={{letterSpacing: 1.5, whiteSpace: 'pre-wrap', lineHeight: 1.6, marginBottom: 40}}>
						뿐만 아니라 카가(Kaga)의 심리다이아 모형에 따라 마음의 의식적 영역과 무의식적 영역을 깊게 이해할 수 있으며, 이를 기반으로 코칭, 상담, 교육 현장에서 다양한 활용이 가능하도록 개발되었습니다.
					</div>

					<b style={{fontSize: 24}}>PTS의 도구적 특성</b>
					<div style={{letterSpacing: 1.5, whiteSpace: 'pre-wrap', lineHeight: 1.6, marginTop: 16}}>
						PTS는 심리학적 원리와 교육학적 원리가 혼합된 교육도구이자 분석도구입니다. 체크리스트 및 자가보고식 형태의 일반적 심리검사와 달리 PTS는 해당하는 기준을 일정한 기준에 따라 스티커를 부착하며 놀이 방식으로 자신을 탐색하고, 상대방과 소통하는 도구입니다.

						따라서 나타난 결과를 쉽게 일반화하는 것이 아닌 전문가와의 분석상담과 스스로의 해석에 따라 자신을 탐색하고 이해하는 도구입니다. 같은 외향형(E)일지라도 행동이 뚜렷한 외향이 존재하고, 외향성을 기반으로 하되 내향적인 면도 함께 드러나는 외향형(E)도 있습니다. PTS에서는 이를 대문자 E와 소문자 e로 표기하며, 다른 지표도 동일한 기준이 적용되고 있습니다.

						뿐만 아니라 같은 내향형(I)이지만 말로 표현하는 것을 불편해하는 내향도 있지만 말로 표현하는 것을 비교적 편안하게 느끼는 내향도 존재합니다. PTS는 탐색 결과를 단순하게 특정 지표를 일반화하는 것이 아닌 같은 지표, 또는 유형 안에서 다른 사람들과 어떻게 다른지 자신만의 특색을 제시한다는 것에서 차이점이 있습니다.
					</div>

					<div align={'center'} style={{marginTop: 40, marginBottom: 40}}>
						<img src={require('../../assets/intro2.png')} style={{width: '80%'}}/>
					</div>

					<div style={{letterSpacing: 1.5, whiteSpace: 'pre-wrap', lineHeight: 1.6, marginBottom: 40}}>
						이런 자신만의 특색을 탐색하기 위해서는 상호작용이 중요합니다. 전문가와 참여자와의 상호작용, 참여자와 참여자 간의 상호작용, 참여자와 내용 간의 상호작용, 참여자의 내적 상호작용에 따라 심리지표 및 유형을 일반화한 결과가 아닌 그 유형 안에서 자신만의 특색과 개성을 탐색할 수 있습니다.
					</div>

					<b style={{fontSize: 24}}>PTS의 타당성 및 원리</b>
					<div style={{letterSpacing: 1.5, whiteSpace: 'pre-wrap', lineHeight: 1.6, marginTop: 16}}>
						PTS는 심리학적 유형론의 심리지표를 상징하는 단어를 추출하고, 이를 심리유형 전문가의 검증을 받아 내용타당도를 확보하였습니다. 뿐만 아니라 유사 검사인 MBTI와의 일치율과 예언율을 확인하여 예언타당도까지 검증한 심리도구이며, PTS만의 원리를 대한민국 특허청으로부터 기술을 인정받아 특허등록이 완료된 도구입니다.
					</div>

					<div align={'center'} style={{marginTop: 40, marginBottom: 40}}>
						<img src={require('../../assets/intro3.png')} style={{width: '80%'}}/>
					</div>

					<div align={'center'} style={{marginTop: 40, marginBottom: 40}}>
						<img src={require('../../assets/intro4.png')} style={{width: '80%'}}/>
					</div>

					<div style={{letterSpacing: 1.5, whiteSpace: 'pre-wrap', lineHeight: 1.6, marginBottom: 40}}>
						이와 같은 타당성을 기반으로 인지주의와 구성주의가 적용된 도구이며, 지표를 상징하는 각 단어가 각자에게 어떤 맥락과 의미로 구성되어 있는지를 탐색할 수 있습니다. 같은 유형이지만 다른 특색을 지닌 원인을 스스로가 지닌 가치관, 경험, 열등감, 상처로부터 탐색할 수 있으며, 이를 이해하고 의식화하는 것이 PTS의 목적입니다.
					</div>

					<b style={{fontSize: 24}}>PTS의 적용 분야</b>
					<div style={{letterSpacing: 1.5, whiteSpace: 'pre-wrap', lineHeight: 1.6, marginTop: 16}}>
						PTS가 적용되는 분야는 매우 다양합니다. 교육, 상담, 조직 및 인사 등의 영역에 적용이 가능합니다.<br></br><br></br>
						교육 장면에서는 학습자 간의 상호작용을 통해 자신과 타인의 유형과 개별적인 특징을 이해할 수 있고, 상담 장면에서는 내담자의 유형과 개별적인 특징을 깊이있게 분석하여 내담자의 자기이해와 심리적 승화를 촉진할 수 있습니다.
					</div>

					<div align={'center'} style={{marginTop: 40, marginBottom: 40}}>
						<img src={require('../../assets/intro5.png')} style={{width: '80%'}}/>
					</div>

					<div style={{letterSpacing: 1.5, whiteSpace: 'pre-wrap', lineHeight: 1.6, marginBottom: 40}}>
						뿐만 아니라 커뮤니케이션, 팀빌딩, 인적자원에 해당하는 조직개발에 적용될 수 있으며, 개인의 자기이해와 경력개발에도 도움을 줄 수 있습니다.<br></br><br></br>
						PTS는 훈련된 전문가만 사용이 가능하며, 그 자격 조건은 아래와 같습니다.
					</div>

					<b style={{fontSize: 24}}>PTS의 사용자격</b>
					<div style={{letterSpacing: 1.5, whiteSpace: 'pre-wrap', lineHeight: 1.6, marginTop: 16, marginBottom: 40}}>
						PTS는 인간 심리의 전문성을 기반으로 교육적 방법, 상담적 방법을 적용하는 도구로 훈련된 전문가가 다뤄야 하는 도구입니다. 따라서 이 도구를 사용하기 위해서는 ㈜인컬리지에서 주관하는 훈련 프로그램을 이수해야만 합니다.<br></br><br></br>

						PTS를 다루는 전문가를 PTA(Psychological Type Analyst), 한글로 심리유형분석사라 부르며 PTA 입문과정, PTA 심화과정, PTA 전문과정, PTA 활용과정을 통해 전문성을 훈련받을 수 있습니다.<br></br><br></br>

						PTA 자격과정에 참여하기 위해서는 최소 4년제 학사의 조건이 필요하며, 교육 전문가, 상담 전문가라면 더 쉽게 자격과정에 참여할 수 있습니다.<br></br><br></br>

						자세한 안내를 인컬리지 홈페이지[클릭]를 통해 확인할 수 있습니다.
					</div>

					<b style={{fontSize: 24}}>PTS의 종류</b>
					<div style={{letterSpacing: 1.5, whiteSpace: 'pre-wrap', lineHeight: 1.6, marginTop: 16}}>
						PTS에는 에너지 방향, 정보인식 기능, 의사결정 기능, 생활방식, 정서반응의 5가지 척도를 탐색하는 심리유형탐색 도구, 에너지 방향과 생활방식을 통해 도형심리유형과 페르소나 유형을 탐색하는 도형심리탐색 도구가 있습니다. 그리고 어린이 및 청소년에게 적용할 수 있는 PTS로 전 연령과 분야에서 사용이 가능합니다.
					</div>

					<div align={'center'} style={{marginTop: 40, marginBottom: 40}}>
						<img src={require('../../assets/intro6.png')} style={{width: '80%'}}/>
					</div>

				</div>
			</div>
		</>
	)
}

export default WebTestIntro
